import { setContext, getContext } from 'svelte';
import { writable } from 'svelte/store';
// Create a store to keep track of logged in state.
export function initLoggedIn(state = false) {
    const loggedIn = writable(state);
    setContext('LOGGED_IN', loggedIn);
    return loggedIn;
}
// Get the logged in state.
// Default to false to test isolated components.
export function getLoggedIn() {
    return getContext('LOGGED_IN') || writable(false);
}
// Create a store to keep track of cart item count.
export function initCartCount(count = 0) {
    const cartCount = writable(count);
    setContext('CART_COUNT', cartCount);
    return cartCount;
}
// Get the cart count.
// Default to 0 to test isolated components.
export function getCartCount() {
    return getContext('CART_COUNT') || writable(0);
}
